import React from "react";
import { useLocation } from "react-router-dom";
import TopBar from "./TopBar";

function AuthenticatedLayout({
  children,
  onLogout,
  userType = "user",
  userEmail = "",
}) {
  const location = useLocation();

  // Don't show TopBar on lesson steps pages
  const showTopBar = !location.pathname.startsWith("/lesson-steps/");

  return (
    <>
      {showTopBar && (
        <TopBar onLogout={onLogout} userType={userType} userEmail={userEmail} />
      )}
      <div className="flex-1">{children}</div>
    </>
  );
}

export default AuthenticatedLayout;
